import React, { useRef, useState } from 'react'
import AutocompleteBase from '../AutocompleteBase/AutocompleteBase'
import { FieldType } from '../../utils/fieldTypeEnum'
import { IAddressLookup, IDawaAddress } from './types'
import { getOptionLabel, getOptionSelected, modelData, urlBuilder } from './AddressLookupUtils'

export const AddressLookup: React.FC<IAddressLookup> = ({
  name,
  label,
  fieldType,
  fieldWidth,
  disabled,
  required,
  popover,
  ...props
}) => {
  if (fieldType != FieldType.ADDRESS) throw Error('ADDRESS field needs to be a ADDRESS field')

  const [excludeSimilar, setExcludeSimilar] = useState(false)
  const [open, setOpen] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  const setCaret = (value: number) => {
    if (!inputRef) return
    const inputElement = inputRef.current
    if (!inputElement) return
    setTimeout(() => {
      inputElement.focus()
      inputElement.setSelectionRange(value, value)
    }, 1)
  }

  function onChange(value: NonNullable<IDawaAddress>) {
    setOpen(true)
    if (!value) {
      setExcludeSimilar(true)
      setOpen(false)
    }

    if (value?.street) {
      setExcludeSimilar(false)
      const caretPostion = value.forslagstekst.length
      setCaret(caretPostion)
    }
    if (value?.city) {
      /**
       * This function manupulates the position of the keyboard caret, to better help the user write out the full address.
       */
      const caretPostion = value.forslagstekst.length - `${value.postalCode} ${value.city}`.length - 2
      setCaret(caretPostion)
    }
    if (value?.madId) {
      setCaret(value.forslagstekst.length)
      setOpen(false)
    }
  }

  return (
    <AutocompleteBase<IDawaAddress>
      {...props}
      urlBuilder={(searchTerm: string) => urlBuilder(searchTerm, excludeSimilar)}
      onChange={onChange}
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      modelData={modelData}
      name={name}
      label={label}
      fieldType={fieldType}
      fieldWidth={fieldWidth}
      inputRef={inputRef}
      disabled={disabled}
      required={required}
      popover={popover}
      open={open}
    />
  )
}
